/* eslint-disable formatjs/enforce-id */
/* eslint-disable formatjs/enforce-default-message */

import {useErrorMessages} from "@dvrt/graphql-widgets";
import {useCallback} from "react";
import {MessageDescriptor, useIntl} from "react-intl";
import {parseContext} from "./ErrorHelper";

/** The layout of a custom value error from the backend */
export interface CustomValueError {
    type: string;
    context?: any;
}

/** A constructed message that can be passed to FormattedMessage as is */
type Message = MessageDescriptor & {values?: Record<string, any>};

type DisplayErrorMessagesHook = {
    /**
     * Constructs a Message for the given CustomValueError.
     * The [values] field is error type aware, and will contain translated context values where applicable.
     * */
    getMessage: (error: CustomValueError) => Message;
};

/** Hook that provides helper functions to display validation error messages from the backend */
export const useDisplayErrorMessages = (): DisplayErrorMessagesHook => {
    const errorMessages = useErrorMessages();
    const intl = useIntl();

    const getMessage = useCallback(
        (error: CustomValueError): Message => {
            const message = errorMessages[error.type];
            const context = error.context ? parseContext(error.context) : {};

            switch (error.type) {
                case "value_error.insufficient_device_limit_excel": {
                    const deviceTypes: string[] = context.device_types || [];
                    context.device_types = deviceTypes
                        .map((type) => intl.formatMessage({id: type}))
                        .join(", ")
                        .toLowerCase();
                    break;
                }
            }

            return {
                ...message,
                values: context,
            };
        },
        [errorMessages, intl],
    );

    return {
        getMessage,
    };
};
